import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as BookingService from '_services/booking-service';

const initialState = {
    bookingsHistory: null,
    allBookings: null,
    backpage: 'assistance-bookings',
    status: 'idle',
    error: null,
    sitaMessages: {
        rows: [],
        totalRows: 0
    },
    sitaMessagesStatus: 'idle',
    sitaMessagesError: null
};

// get all bookings //
export const getUserBookings = createAsyncThunk('bookingsHistory/getUserBookings', async () => {
    return BookingService.getBookingsHistory();
});

export const getAllBookings = createAsyncThunk('bookingsHistory/getAllBookings', async (date) => {
    return BookingService.getAllBookingHistory(date);
});

export const getSitaMessages = createAsyncThunk('bookingsHistory/getAllBookings', async (params) => {
    return BookingService.getSitaMessages(params);
});

const bookingsHistorySlice = createSlice({
    name: 'bookingsHistory',
    initialState,
    reducers: { reset: (state) => initialState },
    extraReducers: {
        [getUserBookings.pending]: (state, action) => {
            return {
                ...state,
                status: 'loading',
            }
        },
        [getUserBookings.fulfilled]: (state, action) => {
            return {
                ...state,
                status: 'succeeded',
                bookingsHistory: action.payload,
            }
        },
        [getUserBookings.rejected]: (state, action) => {
            return {
                ...state,
                status: 'failed',
                error: action.error.message,
            }
        },
        [getAllBookings.pending]: (state, action) => {
            return {
                ...state,
                status: 'loading',
            }
        },
        [getAllBookings.fulfilled]: (state, action) => {
            return {
                ...state,
                status: 'succeeded',
                allBookings: action.payload,
            }
        },
        [getAllBookings.rejected]: (state, action) => {
            return {
                ...state,
                status: 'failed',
                error: action.error.message,
            }
        },
        [getSitaMessages.pending]: (state, action) => {
            return {
                ...state,
                sitaMessagesStatus: 'loading',
            }
        },
        [getSitaMessages.fulfilled]: (state, action) => {
            state.sitaMessagesStatus = 'succeeded';
            if (!state.sitaMessages) state.sitaMessages = {}
            state.sitaMessages["rows"] = action.payload.rows;
            state.sitaMessages["totalRows"] = action.payload.totalCount;
        },
        [getSitaMessages.rejected]: (state, action) => {
            return {
                ...state,
                sitaMessagesStatus: 'failed',
                sitaMessagesError: action.error.message,
            }
        }
    }
});

export const selectBookingsHistory = (state) => {
    if (state.bookingsHistory.bookingsHistory == null ||
        state.bookingsHistory.bookingsHistory == undefined) { return [] };

    // loop through all bookings check if they are active
    let group = {};

    state.bookingsHistory.bookingsHistory.forEach((booking) => {

        let assistanceList = ''
        booking.assistance.forEach(assistance => {
            if (assistance == '') { }
            else if (assistance == 'ENDPAL') { }
            else { assistanceList = assistanceList + assistance.trim() + ' ' }
        })

        let bookingObject = {
            'passenger': booking.name,
            'flight': booking.flightDetails.carrierCode + booking.flightDetails.flightNumber,
            'origin': booking.flightConfirmationDetails.origin,
            'destination': booking.flightConfirmationDetails.destination,
            'assistance': assistanceList,
            'bio': booking.bio ? booking.bio : '',
            'timeCreated': booking.dateCreated ? booking.dateCreated : '',
            'date': booking.flightConfirmationDetails.departureDate
        }

        if (group[booking.flightConfirmationDetails.departureDate]) {
            // push to list
            group[booking.flightConfirmationDetails.departureDate].push(bookingObject)
        }
        // if index does not exsist
        else {
            // create new index with booking in group
            group[booking.flightConfirmationDetails.departureDate] = bookingObject;
        }
    });

    return group;
}

export const selectAllBookings = (state) => {
    if (state.bookingsHistory.allBookings == null ||
        state.bookingsHistory.allBookings == undefined) { return [] };

    // loop through all bookings check if they are active
    let list = [];

    state.bookingsHistory.allBookings.forEach((booking) => {

        let assistanceList = ''
        let bookingDate = booking.doc.flightConfirmationDetails.departureDate;

        if (booking.doc && booking.doc.assistance) {
            booking.doc.assistance.forEach(assistance => {
                if (assistance == '') { }
                else if (assistance == 'ENDPAL') { }
                else { assistanceList = assistanceList + assistance.trim() + ' ' }
            })
        }

        if (booking && booking.doc.name) {
            let bookingObject = {
                'passenger': booking.doc.name,
                'flight': booking.doc.flightDetails.carrierCode + booking.doc.flightDetails.flightNumber,
                'origin': booking.doc.flightConfirmationDetails.origin,
                'destination': booking.doc.flightConfirmationDetails.destination,
                'assistance': assistanceList,
                'bio': booking.doc.bio ? booking.doc.bio : '',
                'timeCreated': booking.doc.dateCreated ? booking.doc.dateCreated : '',
                'date': booking.doc.flightConfirmationDetails.departureDate,
            }

            list.push(bookingObject)

        }
    });

    return list;
}

export const selectBookingsGrouped = (state) => {
    if (state.bookingsHistory.bookingsHistory == null ||
        state.bookingsHistory.bookingsHistory == undefined) { return [] };

    // loop through all bookings check if they are active
    let group = {};

    state.bookingsHistory.bookingsHistory.forEach((booking) => {
        let assistanceList = ''
        booking.assistance.forEach(assistance => {
            if (assistance == '') { }
            else if (assistance == 'ENDPAL') { }
            else { assistanceList = assistanceList + assistance.trim() + ' ' }
        })

        let bookingObject = {
            'passenger': booking.name.toLowerCase(),
            'flight': booking.flightDetails.carrierCode + booking.flightDetails.flightNumber,
            'origin': booking.flightConfirmationDetails.origin,
            'destination': booking.flightConfirmationDetails.destination,
            'assistance': assistanceList,
            'bio': booking.bio ? booking.bio : '',
            'timeCreated': booking.dateCreated ? booking.dateCreated : '',
            'date': booking.flightConfirmationDetails.departureDate
        }

        // if index exsists
        if (group[booking.flightConfirmationDetails.departureDate]) {
            // push to list
            group[booking.flightConfirmationDetails.departureDate].push(bookingObject)
        }
        // if index does not exsist
        else {
            // create new index with booking in group
            group[booking.flightConfirmationDetails.departureDate] = [bookingObject];
        }
    });
    return group;
}

export const { reset, setDate, setBackpage } = bookingsHistorySlice.actions;
export const selectBookingsHistoryStatus = state => state.bookingsHistory.status;
export const selectBackpage = state => state.bookingsHistory.backpage;

export const selectSitaMessagesStatus = state => state.bookingsHistory.sitaMessagesStatus;
export const selectSitaMessagesData = state => {
    const sitaMessagesData = state.bookingsHistory.sitaMessages;
    if (!sitaMessagesData) {
        return {
            rows: [],
            totalRows: 0
        }
    } else return sitaMessagesData
}


export default bookingsHistorySlice.reducer;
